// ログDBの主キー（uuid v4）をブラウザで作る。送る前から ID が決まるので、
// 子の行（回答・選び直し）が親（取り組み）の ID を参照でき、再送しても同じ ID のまま
// （DB 側で重複＝保存済みと判定できる）。crypto.randomUUID が無い環境（http・古い端末・テスト）でも動かす。
export function newId() {
  const c = typeof window !== 'undefined' ? window.crypto : undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const bytes = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
